<template>
  <login></login>
</template>

<script>
import Login from "../Login/Login.vue";
import httpActions from "../../plugins/httpActionService";
import { useStore } from "../../store";

export default {
  components: {
    Login,
  },
  computed: {
    returnCscClientID() {
      return useStore().cscClientId;
    },
  },
  mounted() {
    httpActions.getAssets();
    httpActions.tokenActive("/main", "/login", this.$route.query);
    if (this.returnCscClientID === '3') {
      fbq("track", "PageView");
      const yl = document.createElement('script')
      yl.type = 'text/javascript'
      yl.async = true
      yl.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'm-' + 'dudacarsmb' + '.youlead.pl/m.js?ts=' + (new Date()).getTime();
      document.getElementsByTagName('body')[0].appendChild(yl);
    }
  },
};
</script>
